import React, { useEffect } from 'react'
import { Box } from '@mui/material'

import { AppCardTitle, AppDataTable, AppFilterPanel, AppResultsSkeleton, filterPanelGridSx } from '@components'
import BatchDateFilter from './dateFilter'
import { createdColumn, historyColumn, idColumn, numSearchesColumn, officesColumn, sitesColumn } from './columns'
import { useBatchTableInfo, useManageBatchStatus } from '../@hooks'
import { batchListData } from 'Pages/Batch/Page/@signals'
import ExecutionToolbarSelect from "./Toolbar";
import { isTourDemoActive } from '@signals/app'


export default function BatchTable() {
	const { isLoading, setDateFilter, dateFilter } = useBatchTableInfo()
	useManageBatchStatus()

	useEffect(() => {
		setDateFilter()
	}, [])

	// During the tour with no batches of its own, the sample table stands in for this one
	const showTable = !(isTourDemoActive.value && !batchListData.value?.length && !isLoading.value)

	return <>
		<AppFilterPanel>
			<Box sx={filterPanelGridSx(4)}>
				<BatchDateFilter value={dateFilter.value} onChange={setDateFilter}/>
			</Box>
		</AppFilterPanel>
		{isLoading.value
		? <AppResultsSkeleton columns={6}/>
		// cells a little tighter than the default 16px: at 1440 with the menu open the Status column was cut
		: showTable && <Box sx={{ '& .MuiTableCell-root': { px: 1.25 } }}><AppDataTable
			title={<AppCardTitle icon="clipboard-list" title="Batch List"/>}
			toolbarProps={{ actions: false }}
			data={batchListData.value}
			columns={[
				idColumn(),
				...sitesColumn(),
				...officesColumn(),
				numSearchesColumn(),
				...createdColumn(),
				historyColumn(),
			]}
			options={{
				selectableRows: 'multiple',
				customToolbarSelect: (selectedData, setSelectedRows) => <ExecutionToolbarSelect
					selectedData={selectedData}
					setSelectedRows={setSelectedRows}/>,
			}}
			setHeaderCellProps={() => ({ sx: { fontWeight: 'bold' } })}
			setBodyCellProps={() => ({ sx: { width: 250 } })}
		/></Box>}
	</>
}